import type { LeadItem, LeadSource, LeadStatus } from "../types/lead.types";

export const leadStatuses: LeadStatus[] = [
	{ id: "new", name: "Yangi", nameRu: "Новый", color: "#2474d6", order: 1 },
	{ id: "proc", name: "Jarayonda", nameRu: "В процессе", color: "#cc8a00", order: 2 },
	{ id: "sold", name: "Sotildi", nameRu: "Продано", color: "#0f9d58", order: 3 },
	{ id: "lost", name: "Bekor qilingan", nameRu: "Отменён", color: "#64748b", order: 4 },
];

export const sourceLabels: Record<LeadSource, string> = {
	direct: "Direct",
	facebook: "Facebook",
	google: "Google",
	instagram: "Instagram",
	telegram: "Telegram",
};

export const sourceColors: Record<LeadSource, string> = {
	direct: "slate",
	facebook: "blue",
	google: "amber",
	instagram: "violet",
	telegram: "sky",
};

export const buildingOptions = ["Dream", "Yunusobod", "Unicorp City"];

export const managerOptions = ["Sardor T.", "Kamol X.", "Aziza R."];

export const leadsMock: LeadItem[] = [
	{
		id: "1",
		name: "Isroil Tursunov",
		phone: "+998 94 567 89 09",
		source: "facebook",
		managerName: "Sardor T.",
		managerInitials: "ST",
		buildingName: "Dream",
		budget: "650 mln",
		roomInterest: "2 xona",
		calls: 2,
		statusId: "new",
		createdAt: "Bugun",
		lastActivity: "15 daqiqa oldin",
	},
	{
		id: "2",
		name: "Bobur Yusupov",
		phone: "+998 90 123 45 67",
		source: "instagram",
		managerName: "Kamol X.",
		managerInitials: "KX",
		buildingName: "Unicorp City",
		budget: "920 mln",
		roomInterest: "3 xona",
		calls: 0,
		statusId: "new",
		createdAt: "Bugun",
		lastActivity: "1 soat oldin",
	},
	{
		id: "3",
		name: "Nodira Karimova",
		phone: "+998 93 000 11 22",
		source: "telegram",
		managerName: "Sardor T.",
		managerInitials: "ST",
		buildingName: "Yunusobod",
		budget: "510 mln",
		roomInterest: "1 xona",
		calls: 1,
		statusId: "new",
		createdAt: "Kecha",
		lastActivity: "2 soat oldin",
	},
	{
		id: "4",
		name: "Sherzod Aliyev",
		phone: "+998 91 222 33 44",
		source: "google",
		managerName: "Aziza R.",
		managerInitials: "AR",
		buildingName: "Dream",
		budget: "1.2 mlrd",
		roomInterest: "4 xona",
		calls: 0,
		statusId: "proc",
		createdAt: "2 kun oldin",
		lastActivity: "Bugun",
	},
	{
		id: "5",
		name: "Madina Yusupova",
		phone: "+998 97 888 99 00",
		source: "facebook",
		managerName: "Kamol X.",
		managerInitials: "KX",
		buildingName: "Unicorp City",
		budget: "780 mln",
		roomInterest: "2 xona",
		calls: 3,
		statusId: "proc",
		createdAt: "3 kun oldin",
		lastActivity: "Kecha",
	},
	{
		id: "6",
		name: "Jasur Mirzayev",
		phone: "+998 99 111 22 33",
		source: "instagram",
		managerName: "Sardor T.",
		managerInitials: "ST",
		buildingName: "Dream",
		budget: "845 mln",
		roomInterest: "3 xona",
		calls: 0,
		statusId: "sold",
		createdAt: "5 kun oldin",
		lastActivity: "Sotuvga o'tdi",
	},
	{
		id: "7",
		name: "Anvar Rahimov",
		phone: "+998 90 555 66 77",
		source: "direct",
		managerName: "Aziza R.",
		managerInitials: "AR",
		buildingName: "Yunusobod",
		budget: "430 mln",
		roomInterest: "1 xona",
		calls: 1,
		statusId: "lost",
		createdAt: "1 hafta oldin",
		lastActivity: "Bekor qilindi",
	},
];
